function initProductGridItemColors(context = document) {
  context.querySelectorAll(".js-product-grid-item-color").forEach(function (colorLink) {
    if (colorLink.dataset.listenerAdded === "true") return; // zabezpieczenie przed wielokrotnym dodaniem listenera
    colorLink.dataset.listenerAdded = "true";

    const productItem = colorLink.closest(".product-grid-item");
    if (!productItem) return;

    const imgWrapper = productItem.querySelector(".product-grid-item__image a");
    const mainImg = imgWrapper?.querySelector("img:first-of-type");
    if (!mainImg) return;

    colorLink.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    colorLink.addEventListener("mouseenter", function (e) {
      e.preventDefault();

      productItem.querySelectorAll(".product-grid-item__color").forEach(function (colorEl) {
        colorEl.classList.remove("active");
      });

      const colorWrapper = this.querySelector(".product-grid-item__color");
      if (colorWrapper) colorWrapper.classList.add("active");

      const secondImg = imgWrapper.querySelector("img:nth-of-type(2)");
      if (secondImg) secondImg.remove();

      const newImage = this.getAttribute("data-color-image");
      if (newImage) {
        mainImg.setAttribute("src", newImage);
        mainImg.removeAttribute("srcset");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initProductGridItemColors();
});